import { render, staticRenderFns } from "./WpLabRequest.vue?vue&type=template&id=3c604f16&scoped=true"
import script from "./WpLabRequest.vue?vue&type=script&lang=js"
export * from "./WpLabRequest.vue?vue&type=script&lang=js"
import style0 from "./WpLabRequest.vue?vue&type=style&index=0&id=3c604f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c604f16",
  null
  
)

export default component.exports